import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import {
    CHECK_CLIENT_EMAIL_STATUS_BY_EVENT,
    DELETE_CLIENT_EMAIL_STATUS_BY_EVENT,
    GET_CLIENT_EMAIL_EVENTS, GET_CLIENT_EMAIL_TEMPLATE_BY_ID
} from "./actionTypes"

import {
    getClientEmailEventsSuccess,
    getClientEmailEventsError,
    getClientEmailTemplateByIdSuccess,
    getClientEmailTemplateByIdError,
    checkClientEmailStatuByEventSuccess,
    checkClientEmailStatuByEventError,
    deleteClientEmailStatusByEventSuccess,
    deleteClientEmailStatusByEventError
} from "./actions"

import {
    genericGetRequest_2, genericPostRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getClientUserDetails } from "helpers/sf_browser_storage_helper"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const inFlightClientEmailEventRequests = new Set()

function* onGetClientEmailEvents(action) {
    try {
        const useCache = Boolean(action.payload?.useCache)
        const queryParams = action.payload?.queryParams || {}
        const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
        const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
        const requestKey = `${cacheKey}:${requestedPageNumber}`
        const cachedPage = useCache
            ? yield select((state) => state.ClientEmailEvents.page_cache?.[cacheKey]?.[requestedPageNumber])
            : null

        if (useCache && cachedPage) {
            return
        }

        if (useCache && inFlightClientEmailEventRequests.has(requestKey)) {
            return
        }

        if (useCache) {
            inFlightClientEmailEventRequests.add(requestKey)
        }

        let user = bsh_getClientUserDetails();
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/client_email_events`,
            queryParams,
            {
                Authorization: user.token,
                account_id: user.account_id,
            }
        )
        yield put(getClientEmailEventsSuccess(response, {
            appendResults: Boolean(action.payload?.appendResults),
            queryParams,
            useCache,
        }))
    } catch (error) {
        yield put(getClientEmailEventsError(error))
    } finally {
        if (action.payload?.useCache) {
            const queryParams = action.payload?.queryParams || {}
            const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
            const cacheKey = buildPaginationCacheKey(queryParams)
            inFlightClientEmailEventRequests.delete(`${cacheKey}:${requestedPageNumber}`)
        }
    }
}

function* onGetClientEmailTemplates(action) {
    try {
        let user = bsh_getClientUserDetails();
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/client_email_template_logs/${action.payload.template_id}`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
                account_id: user.account_id,
            }
        )
        yield put(getClientEmailTemplateByIdSuccess(response))
    } catch (error) {
        yield put(getClientEmailTemplateByIdError(error))
    }
}

function* onCheckClientEmailEvent(action) {
    try {
        let user = bsh_getClientUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/check_client_email_event_status`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: user.token,
              'account-id': user.account_id,
              'Content-Type': 'application/json',
            },
          }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(checkClientEmailStatuByEventSuccess(response))
    } catch (error) {
        yield put(checkClientEmailStatuByEventError(error))
    }
}

function* onDeleteClientEmailEventById(action) {
    try {
        let auth_user = bsh_getClientUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/delete_client_email_from_suppression_list`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: auth_user.token,
              'account-id': auth_user.account_id,
              'Content-Type': 'application/json',
            },
          }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(deleteClientEmailStatusByEventSuccess(response))
    } catch (error) {
        yield put(deleteClientEmailStatusByEventError(error))
    }
}

function* ClientEmailEventsSaga() {
    yield takeLatest(GET_CLIENT_EMAIL_EVENTS, onGetClientEmailEvents),
    yield takeEvery(GET_CLIENT_EMAIL_TEMPLATE_BY_ID, onGetClientEmailTemplates)
    yield takeEvery(CHECK_CLIENT_EMAIL_STATUS_BY_EVENT, onCheckClientEmailEvent)
    yield takeEvery(DELETE_CLIENT_EMAIL_STATUS_BY_EVENT, onDeleteClientEmailEventById)
}

export default ClientEmailEventsSaga
